import { motion } from "framer-motion";

const CHAPTERS = [
    { chapter: "01", title: "Every state. Every player.",
        body: "Ranked Play Tournaments exists to find the best competitive gamers in every state in America — not the best in Los Angeles, not the best in New York, the best everywhere. Talent doesn't cluster by zip code and neither does our circuit. All fifty states run brackets at the same time, and every winner goes on stream." },
    { chapter: "02", title: "Locked to your home state.",
        body: "Every player registers with the state they live in — confirmed by ID. Your account is locked to your home state's circuit: its qualifiers, its ladder, its championship. If you live there and you compete, you're on that state's ladder." },
    { chapter: "03", title: "Open qualifier. Ruthless bracket.",
        body: "Both Modern Warfare 4 qualifiers run open in every state — Warzone squads and 4v4 Multiplayer teams enter until registration closes. Top thirty squads in each bracket advance to the semifinals, then the finalists play for the state crown. Two formats. Two broadcast tracks. Full VODs published after every match." },
    { chapter: "04", title: "One state champion per title.",
        body: "Every state crowns exactly two champions — one Warzone squad and one MW4 Multiplayer team. Their names live on the wall forever. Their trophies go home with them. No shared podiums, no consolation prizes." },
    { chapter: "05", title: "State champions go national.",
        body: "A state championship isn't the finish line — it's the ticket. All one hundred state champions advance to the national stage. That's the whole plan: state ladder → state championship → national final. Fifty states worth of the best." },
];

export default function Manifesto() {
    return (
        <div className="pt-[68px]" data-testid="manifesto-page">
            <section className="max-w-[1600px] mx-auto px-6 md:px-10 pt-24 pb-12">
                <div className="overline mb-6">[ 00 ] Doctrine · Season 1 · All 50 States</div>
                <h1 className="font-display font-black tracking-tighter leading-[0.86] text-5xl md:text-[10vw]">
                    The <br />
                    <span className="text-outline-strong">mission.</span>
                </h1>
                <p className="mt-8 max-w-2xl text-secondary text-base md:text-lg leading-relaxed">
                    Find the best player in every state — all fifty, right now. Open Call of Duty: Modern Warfare 4 qualifiers in Warzone and Multiplayer, locked to your home state. Top 30 squads in each bracket advance to the semifinals. State champions represent their state on the national stage.
                </p>
            </section>

            <section className="max-w-[1600px] mx-auto px-6 md:px-10 pb-32 space-y-24">
                {CHAPTERS.map((c, i) => (
                    <motion.div key={c.chapter}
                        initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                        className="grid md:grid-cols-12 gap-8 items-baseline border-t border-white/10 pt-16">
                        <div className="md:col-span-3 font-mono text-volt text-sm tracking-[0.3em]">[ {c.chapter} ]</div>
                        <h3 className="md:col-span-5 font-display font-black tracking-tight text-3xl md:text-5xl leading-[1.02]">
                            {c.title}
                        </h3>
                        <p className="md:col-span-4 text-secondary text-base md:text-lg leading-relaxed">{c.body}</p>
                    </motion.div>
                ))}
            </section>
        </div>
    );
}
